import { configureStore } from '@reduxjs/toolkit';
import user from '../slices/userSlice';
import modal from '../slices/modalSlice';
import announceModal from '../slices/announceModalSlice';
import shareWishlistModal from '../slices/shareWishlistModalSlice';
import availabilityModal from '../slices/availabilityModalSlice';

const store = configureStore({
  reducer: {
    user,
    modal,
    announceModal,
    shareWishlistModal,
    availabilityModal,
  },
});

export default store;
